// extracted by mini-css-extract-plugin
export var alignCenter = "_8e-d";
export var bannerShown = "_8e-6";
export var buttonContent = "_8e-0";
export var cardList = "_8e-1";
export var centerContent = "_8e-2";
export var chevron = "_8e-3";
export var closePanelButton = "_8e-k";
export var conversationContextContainer = "_8e-l";
export var conversationDetailContainer = "_8e-4";
export var detailWrapper = "_8e-7";
export var dropdownButton = "_8e-e";
export var dropdownTitle = "_8e-9";
export var fullHeight = "_8e-5";
export var hidden = "_8e-a";
export var icon = "_8e-b";
export var mergeSuggestionWrapper = "_8e-m";
export var panel = "_8e-i";
export var portalButtonsWrapper = "_8e-c";
export var right = "_8e-j";
export var tableSummaryContainer = "_8e-8";
export var tableSummaryHeader = "_8e-g";
export var threeDotsButton = "_8e-f";
export var wide = "_8e-h";